import { useApi } from './useApi';

let cache: any[] | null = null;

export function useProveedores() {
  // El backend pagina de a 50 por defecto: sin límite explícito los buscadores no encontraban los proveedores siguientes.
  // ponytail: lista completa de una vez; si pasan de 1000, pasar a búsqueda en el servidor.
  const result = useApi<any[]>('/api/v3/proveedores?limit=1000');
  if (!cache && result.data) cache = result.data;
  return { ...result, data: result.data || cache };
}
